exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1_lIs-Q6DzoptpNdjPHgXO{background:url(" + require("../img/Misc/button.png") + ") 50% no-repeat;background-size:contain;cursor:pointer;padding:10px 20px;font-size:2em;font-weight:700}._1_lIs-Q6DzoptpNdjPHgXO:hover{transform:scale(1.1)}._1_lIs-Q6DzoptpNdjPHgXO:active{transform:scale(1)}", ""]);

// exports
exports.locals = {
	"racer-btn": "_1_lIs-Q6DzoptpNdjPHgXO",
	"racerBtn": "_1_lIs-Q6DzoptpNdjPHgXO"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&camelCase!./src/styles/common.css
// module id = 21
// module chunks = 0